<template>
  <div class="c-chart" :style="{'max-width': maxWidth}">
    <vue-highcharts
      type="chart"
      :options="chartOptions"
      :redrawOnUpdate="true"
      :oneToOneUpdate="false"
      :animateOnUpdate="true"
    />
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import VueHighcharts from 'vue3-highcharts';
// import Highcharts from 'highcharts';

export default defineComponent({
  name: 'Chart',
  components: {
    VueHighcharts,
  },
  props: {
    chartOptions: {
      type: Object,
      default: () => ({}),
    },
    maxWidth: {
      type: String,
      default: '100%',
    },
  },

});
</script>
<style lang="scss" scoped>
.c-chart {
  margin: 20px auto;
}
</style>
